/**
 * Created by H
 * User: huangcan
 * Date: 2019-09-29
 * Time: 11:28
 * tips:
 */
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['filterDownData'])
  }
}
